// extracted by mini-css-extract-plugin
module.exports =  {"alertMessage":"uxGREviMlXsruCXM1nLt","amount":"GpziDApXGA6BpkvmR5O3","animationWrapper":"ACSpyJm33bemTO1LVmsI","projectName":"OP64r3TT4RjPxcHOB0fM"};